export const pictureUpload = {
  PICTURE_UPLOAD_LOADING: 'PICTURE_UPLOAD_LOADING',
  PICTURE_UPLOAD_SUCCESS: 'PICTURE_UPLOAD_SUCCESS',
  PICTURE_UPLOAD_FAILURE: 'PICTURE_UPLOAD_FAILURE'
};
